export default {
    init() {
        const blocks = document.querySelectorAll('.flip-filter-posts-block');
        if (!blocks.length) return;

        blocks.forEach((block) => {
            const resultsElement = block.querySelector('.flip-filter-posts-block-body');
            const inner = block.querySelector('.flip-filter-posts-block__inner');
            const cateDropdown = block.querySelector('.flip-filter-posts-block--cate-dropdown');
            const loadMoreLink = block.querySelector('.flip-filter-posts-block--load-more > a');
            const loadMoreWrapper = loadMoreLink ? loadMoreLink.parentElement : null;
            const spinnerWrap = block.querySelector('.spinner-wrap');
            const currentCate = block.querySelector('#data-cate');

            if (!resultsElement || !loadMoreLink || !currentCate) return;

            const rawQuery = inner ? inner.dataset.query : '{}';

            let query = {};
            try {
                query = typeof rawQuery === 'string' ? JSON.parse(rawQuery) : (rawQuery || {});
            } catch (error) {
                console.error('Invalid query JSON in data-query:', rawQuery);
                query = {};
            }

            const syncDataAttr = (el, key, value) => {
                if (!el) return;
                el.dataset[key] = value;
                el.setAttribute(
                    `data-${key.replace(/[A-Z]/g, (m) => `-${m.toLowerCase()}`)}`,
                    value
                );
            };

            const setLoadingState = (isLoading) => {
                if (!spinnerWrap) return;
                spinnerWrap.classList.toggle('__is-loading', Boolean(isLoading));
                if (loadMoreLink) {
                    loadMoreLink.setAttribute('aria-busy', isLoading ? 'true' : 'false');
                    loadMoreWrapper.classList.toggle('loading', isLoading);
                }
            };

            const updateLoadMoreState = (currentPage, maxPages) => {
                syncDataAttr(loadMoreLink, 'currentpage', currentPage);
                syncDataAttr(loadMoreLink, 'max_num_pages', maxPages);

                if (loadMoreWrapper) {
                    loadMoreWrapper.style.display = Number(currentPage) >= Number(maxPages) ? 'none' : '';
                }
            };

            const renderItems = (items, loadMore) => {
                if (loadMore) {
                    resultsElement.insertAdjacentHTML('beforeend', items);
                } else {
                    resultsElement.innerHTML = items;
                }
            };

            const appendQueryToFormData = (formData, obj, parentKey = 'query') => {
                if (!obj || typeof obj !== 'object') return;

                Object.entries(obj).forEach(([key, value]) => {
                    const formKey = `${parentKey}[${key}]`;

                    if (value === null || value === undefined) {
                        return;
                    }

                    if (Array.isArray(value)) {
                        value.forEach((item, index) => {
                            if (item !== null && item !== undefined) {
                                if (typeof item === 'object') {
                                    appendQueryToFormData(formData, item, `${formKey}[${index}]`);
                                } else {
                                    formData.append(`${formKey}[${index}]`, String(item));
                                }
                            }
                        });
                        return;
                    }

                    if (typeof value === 'object') {
                        appendQueryToFormData(formData, value, formKey);
                        return;
                    }

                    formData.append(formKey, String(value));
                });
            };

            const fetchFilteredPosts = async ({ idCate, currentpage, loadMore }) => {
                try {
                    setLoadingState(true);

                    const formData = new FormData();
                    formData.append('action', 'flip_ajax_filter_posts');
                    formData.append('idCate', idCate || 'all');
                    formData.append('currentpage', String(currentpage || 1));
                    formData.append('loadMore', loadMore ? 'true' : 'false');

                    appendQueryToFormData(formData, query, 'query');

                    const response = await fetch(block_script.ajax_url, {
                        method: 'POST',
                        credentials: 'same-origin',
                        body: formData,
                    });

                    if (!response.ok) {
                        throw new Error(`AJAX request failed with status ${response.status}`);
                    }

                    const rawResponse = await response.text();
                    if (!rawResponse.trim()) {
                        throw new Error('Empty AJAX response from server.');
                    }

                    let responseData;
                    try {
                        responseData = JSON.parse(rawResponse);
                    } catch (parseError) {
                        console.error('Invalid AJAX JSON response:', rawResponse);
                        throw parseError;
                    }

                    const maxPages = Number(responseData.max_num_pages || 1);
                    updateLoadMoreState(loadMore ? Number(currentpage) + 1 : 1, maxPages);
                    renderItems(responseData.items || '', loadMore);
                } catch (error) {
                    console.error(error);
                } finally {
                    setLoadingState(false);
                }
            };

            if (cateDropdown) {
                cateDropdown.addEventListener('click', (event) => {
                    event.preventDefault();
                    cateDropdown.classList.toggle('active');
                });
            }

            loadMoreLink.addEventListener('click', (event) => {
                event.preventDefault();
                const dataPage = Number(loadMoreLink.dataset.currentpage || 1);

                fetchFilteredPosts({
                    idCate: currentCate.dataset.cate || 'all',
                    currentpage: dataPage,
                    loadMore: true,
                });
            });

            const cateItems = block.querySelectorAll('.flip-filter-posts-block--cate-dropdown ul li');
            cateItems.forEach((item) => {
                item.addEventListener('click', (event) => {
                    event.preventDefault();

                    // Fix: Remove 'active' class from all li items, then add it to the clicked item.
                    cateItems.forEach((li) => li.classList.remove('active'));
                    item.classList.add('active');

                    const nameCate = item.textContent.trim();
                    const dataCate = item.dataset.cate || 'all';
                    const cateTitle = block.querySelector('.flip-filter-posts-block--cate #data-cate');

                    if (cateTitle) {
                        cateTitle.textContent = nameCate;
                        cateTitle.dataset.cate = dataCate;
                        cateTitle.setAttribute('data-cate', dataCate);
                    }

                    currentCate.dataset.cate = dataCate;
                    currentCate.setAttribute('data-cate', dataCate);

                    updateLoadMoreState(1, Number(loadMoreLink.dataset.max_num_pages || 1));

                    fetchFilteredPosts({
                        idCate: dataCate,
                        currentpage: 1,
                        loadMore: false,
                    });
                });
            });
        });
    }
};